import axios from "axios";

export const state = {
    patienttestresults: [],
};

export const getters = {
    patienttestresults: state => state.patienttestresults,
};

export const mutations = {
    setPatients(state, newValue) {
        state.patienttestresults = newValue
    },
};

export const actions = {
    fetchPatientTestresults({ commit }) {
        axios.get('/patienttestresults').then(res => {
            commit('setPatients', res.data.visits)
        })
    },
};
